import { AuthenticatedGuard } from "@/components/authenticated-guard";
import { UserType } from "@/constants";
import { titleAuthConfigured } from "@/lib/title-auth";
import { getTitleLoginConnection } from "@/lib/title-login-connection";
import { Navigate, createFileRoute } from "@tanstack/react-router";

function UnconfiguredHome() {
  return (
    <div className="mx-auto w-full max-w-3xl">
      <h1 className="text-3xl font-bold tracking-tight">
        Request a title response
      </h1>
      <p className="mt-2 text-muted-foreground">
        Title request sign-in is not configured for this environment.
      </p>
    </div>
  );
}

function TitleHomeRedirect() {
  return (
    <AuthenticatedGuard
      allowedUserTypes={[UserType.TITLE_REQUESTOR, UserType.OPERATOR]}
      loginConnection={getTitleLoginConnection()}
    >
      <Navigate to="/title/requests" replace />
    </AuthenticatedGuard>
  );
}

export const Route = createFileRoute("/title/")({
  component: function TitleHome() {
    if (!titleAuthConfigured()) {
      return <UnconfiguredHome />;
    }
    return <TitleHomeRedirect />;
  },
});
